import {
    getModule,
    Module,
    Mutation,
    Action,
    VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';

@Module({
    namespaced: true,
    name: 'alert',
    store,
    dynamic: true,
})
class AlertModule extends VuexModule {
    error: any | null = null;
    news: string | null = null;

    @Mutation
    setError(error: any | null) {
        this.error = error;
    }

    @Mutation
    setNews(news: string | null) {
        this.news = news;
    }

}

export default getModule(AlertModule);
